/* 기간별 BOM 버전 표시 규칙.

   z_bom_version 은 완제품·판매 키트에만 있고 버전 코드는 그 소유 완제품 안에서만 고유하다
   (z_bom_version_uk (item_id, bom_ver_cd)). 그래서 한 반제품이 여러 완제품에 쓰이면 같은 "V1" 이
   여러 건 나오고, 코드만으로는 어느 완제품의 버전인지 구분되지 않는다.

   BomMaster(등록)·BomDetail(전개) 양쪽에서 같은 규칙을 써야 하므로 여기 한 곳에 둔다. */

/* 소유 완제품이 기준 품목과 다를 때만 코드 앞에 붙인다. 완제품·판매 키트는 자기 소유 버전이라
   코드만으로 충분하고, 늘 붙이면 모든 행에 같은 완제품 코드가 중복 표시된다.
   baseItemCd 는 "지금 보고 있는 품목" — 등록 화면은 행의 모품목, 전개 화면은 전개 기준 품목이다. */
const bomVersionLabel = (bomVerCd, ownerItemCd, baseItemCd) => {
  if (!bomVerCd) {
    return "";
  }

  return ownerItemCd && ownerItemCd !== baseItemCd ? `${ownerItemCd} / ${bomVerCd}` : bomVerCd;
};

const bomVersionUtils = {
  bomVersionLabel
};

export default bomVersionUtils;
